export default __webpack_public_path__ + "static/media/bg_music.d9341edd.mp3";